<template>
    <div class="container">
        <v-alert outlined type="info">A parking violation/ticket is not eligible for payment online once it has been processed as a debt owed to the university.</v-alert>
        <div class="flex flex-wrap justify-center content-center items-center">
            <div class="w-full">

                <v-form :action="appURL + '/ticket-payment'" method="POST" v-model="formvalid" ref="form">
                    <input type="hidden" :value="csrfToken" name="_token">
                    <v-card raised>
                        <v-card-title>UIS Parking Ticket Payment Application </v-card-title>
                        <v-card-text>
                            <div class="px-2">
                                <p class="text-lg py-2 font-semibold mr-2">Personal Information</p>
                                <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
                                    <v-text-field outlined v-model="form.full_name" name="full_name" prepend-icon="person" :rules="[rules.required]" label="Name"></v-text-field>
                                    <v-text-field persistent-hint hint= "Beginning with area code ,please enter only digits, no spaces, brackets or hyphens." name="phone" :rules="[rules.phoneLength]" outlined v-model="form.phone" prepend-icon="phone" label="Phone"></v-text-field>
                                    <v-text-field persistent-hint hint= "Please enter the ticket number located at the bottom of the parking violation" name="ticket_number" :rules="[rules.required]" outlined v-model="form.ticket" prepend-icon="work" label="Ticket Number"></v-text-field>
                                    <v-text-field outlined v-model="form.street1" name="street_address_1" :rules="[rules.required]" prepend-icon="apartment" label="Street Address 1"></v-text-field>
                                    <v-text-field name="street_address_2" outlined v-model="form.street2" prepend-icon="apartment" label="Street Address 2"></v-text-field>
                                    <v-text-field name="city" outlined v-model="form.city" prepend-icon="emoji_transportation" :rules="[rules.required]" label="City"></v-text-field>
                                    <v-text-field name="state" outlined v-model="form.state" prepend-icon="location_city" :rules="[rules.required]" label="State"></v-text-field>
                                    <v-text-field name="zip" outlined v-model="form.zip" prepend-icon="business" :rules="[rules.required]" label="Zip"></v-text-field>
                                </div>
                            </div>
                            <div class="px-2">
                                <p class="text-lg py-2 font-semibold mr-2">Parking Payment Information</p>
                                <div class="flex flex-col mt-5">
                                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                                <table class="min-w-full divide-y divide-gray-200">
                                                    <thead class="bg-gray-50">
                                                        <tr>
                                                            <th scope="col" class="px-6 py-3 text-left text-md font-semibold text-blue-500 uppercase tracking-wider">
                                                                Violation Type
                                                            </th>
                                                            <th scope="col" class="px-6 py-3 text-left text-md font-semibold text-blue-500 uppercase tracking-wider">
                                                                Price
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="bg-white divide-y divide-gray-200">
                                                        <tr v-for="(tickettype,i) in tickettypes" :key="i">
                                                            <td class="px-6 py-4 font-medium whitespace-nowrap">
                                                                {{ tickettype.violation_label }}
                                                            </td>
                                                            <td class="px-6 py-4 whitespace-nowrap font-semibold text-red-500">
                                                                <template v-if="tickettype.ticket_prices !== '0'">
                                                                    ${{ tickettype.ticket_prices }}
                                                                </template>
                                                                <template v-else>
                                                                    <v-text-field v-model="form.otherAmount" name="other_amount" outlined label="Enter Amount" type="number" min="0" ></v-text-field>
                                                                </template>
                                                            </td>
                                                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                                <input v-model="form.price" type="radio" :rules="[rules.required]" :value="tickettype.violation_type" name="violation_type" :id="tickettype.violation_type" class="w-5 h-5">
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :loading="loadingReset" outlined color="error" class="mr-4" @click="reset">Reset Form</v-btn>
                            <v-btn :loading="loadingSubmit" type="submit" color="success">Go To Payment</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
                <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
                    {{ snackText }}
                    <v-btn text @click="snack = false">Close</v-btn>
                </v-snackbar>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                formvalid: true,
                loadingReset: false,
                loadingSubmit: false,
                snack: false,
                snackColor: '',
                snackText: '',
                appURL: process.env.MIX_APP_URL,
                csrfToken: document.querySelector('meta[name="csrf-token"]').content,
                form: {
                    full_name: '',
                    phone: '',
                    ticket: '',
                    price: '',
                    street1:'',
                    street2:'',
                    city:'',
                    state:'',
                    zip:'',
                    otherAmount: null,
                },
                rules: {
                    required: value => !!value || "Required.",
                    phoneLength: v => (v || "").length === 10 || "Minimum 10 characters",
                },
            }
        },
        props: {
            tickettypes: {
                required: true,
                type: Array,
            },
        },
        methods:{
            reset () {
                this.loadingReset = true;
                this.$refs.form.reset();
                this.loadingReset = false;
            },
        },
    }

</script>

<style>

</style>